var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-container",style:(_vm.styleContent)},[_c('i',{class:['iconfont', _vm.isFullScreen ? 'icontuichuquanping' : 'iconquanping5'],style:(_vm.style),on:{"click":_vm.handleScreenChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }